import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _path;
const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';
function Info(_ref) {
  let {
      size: sizeProp,
      title,
      titleId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.97 0-9 4.031-9 9a9 9 0 009 9 9 9 0 009-9c0-4.969-4.03-9-9-9zm0 3.992a1.524 1.524 0 110 3.048 1.524 1.524 0 010-3.048zm2.032 9.218c0 .24-.195.435-.435.435h-3.194a.435.435 0 01-.435-.435v-.871c0-.24.195-.436.435-.436h.436v-2.322h-.436a.435.435 0 01-.435-.436v-.87c0-.241.195-.436.435-.436h2.323c.24 0 .435.195.435.435v3.63h.436c.24 0 .435.194.435.435v.87z"
  })));
}
Info.sizes = sizes;
Info.defaultProps = {
  size: sizes.md
};
Info.propTypes = {
  size: PropTypes.oneOf([Info.sizes.xs, Info.sizes.sm, Info.sizes.md, Info.sizes.lg, Info.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default Info;